import { notification } from 'antd';

const Notify = (type, title, message, duration) => {
  notification[type]({
    message: title || 'Notification',
    description: typeof message === 'string' ? message : (message && message.message ? message.message : ''),
    duration: duration !== undefined ? duration : 4.5,
  });
};

export default Notify;
